import { render } from "./Systems.vue?vue&type=template&id=543b5dd4"
import script from "./Systems.vue?vue&type=script&lang=js"
export * from "./Systems.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__